export default __webpack_public_path__ + "static/ic_webinar_iso_27001-6d5257c10e05cda482d5087fbf9abca5.svg";